export const SET_LANG = 'SET_LANG';
export const SET_LOADING = 'SET_LOADING';
export const SET_GO_TO_PAGE = 'SET_GO_TO_PAGE';
export const SET_WINDOW_SIZES = 'SET_WINDOW_SIZES';
export const SET_SELECTED_PROJECT = 'SET_SELECTED_PROJECT';
export const SET_FIRST_TYPE_PORTFOLIO_DATA = 'SET_FIRST_TYPE_PORTFOLIO_DATA';
export const SET_SECOND_TYPE_PORTFOLIO_DATA = 'SET_SECOND_TYPE_PORTFOLIO_DATA';
